import axios from "axios";
import { API_URL } from "constants";
import { setToken } from "@redux";
import store from "@redux/store";

export async function getRequest(URL) {
  const reduxData = store.getState();
  const token = reduxData.persisted.token;
  const driverInfo = reduxData.persisted.driverInfo;
  const status = driverInfo.status;
  const getAxios = axios.create();

  getAxios.defaults.timeout = 15000; // 15 sn
  getAxios.defaults.baseURL = API_URL;
  getAxios.defaults.headers = {
    Authorization: `Bearer ${token}`,
  };
  getAxios.interceptors.response.use(
    function (response) {
      if (driverInfo.length !== 0) {
        if (status !== 1) {
          console.log("getRequest, sürücü ihraç edilmiş, token siliniyor.");
          store.dispatch(setToken(""));
        } else {
          console.log("getRequest successed");
          return response;
        }
      } else {
        console.log("getRequest, driverInfo boş döndü.");
      }
    },
    function (error) {
      if (error.response && error.response.status === 401) {
        console.log("getRequest failed");
      }
      return Promise.reject(error);
    }
  );
  return getAxios.get(URL).then((response) => response.data);
}
